/**
 * useAnnotationTimeline Hook
 * 
 * Manages the timeline data generation for annotations.
 * Processes annotations and converts them to timeline items with:
 * - Proper formatting
 * - Severity indicators
 * - Interactive handlers
 * - Bulk selection support
 */
import { useEffect, useState } from 'react';

const useAnnotationTimeline = ({
  annotations,
  bulkEdit,
  bulkSelectedItems,
  showUnreviewed,
  showReviewerTools,
  showDetails,
  ExamSessionStore,
}) => {
  const types = ['flags'];
  const [timelineData, setTimelineData] = useState([]);
  const [initialized, setInitialized] = useState(false);

  // Build timeline data from annotations - store raw data, not JSX
  useEffect(() => {
    const tempTimelineData = [];
    let allAnnotations = ExamSessionStore.getAnnotations({ types });

    // Remove any annotations where the start is less than 0
    allAnnotations = allAnnotations.filter((annotation) => annotation.start >= 0);

    // Filter for unreviewed if needed
    if (showUnreviewed) {
      allAnnotations = allAnnotations.filter((annotation) => !annotation.reviewedDate);
    }

    for (const annotation of allAnnotations) {
      // Store raw annotation data instead of JSX
      // This allows proper memoization in TimelineItem
      const annotationOnTimeline = {
        id: annotation.sid,
        annotation: annotation, // Raw annotation data
        time: annotation.start,
        // Store metadata for rendering
        _meta: {
          bulkEdit,
          isSelected: bulkSelectedItems.includes(annotation.sid),
          showReviewerTools: showReviewerTools,
          showDetails,
        }
      };
      tempTimelineData.push(annotationOnTimeline);
    }
    setTimelineData(tempTimelineData);
    setInitialized(true);
  }, [annotations, annotations?.length, bulkEdit, bulkSelectedItems, showUnreviewed, showReviewerTools, showDetails, ExamSessionStore]);

  return {
    timelineData,
    initialized,
  };
};

export default useAnnotationTimeline;
